import Controller from "../../../../core/js/Controller";

export default class Forecasts extends Controller {
    afterInit() {
        let hash = document.location.hash.replace('#', '');
        if (hash) {
            this.openTab(hash);
        }
    }

    changeTab(e, el) {
        e.preventDefault();
        // document.location.hash = '#' + el.dataset.tab;

        this.openTab(el.dataset.tab);
    }

    openTab(tab_name) {
        this.tab_link_forecasts.removeClass('active');
        this.tab_link_results.removeClass('active');
        this.tab_link_rules.removeClass('active');
        this.tab_link_gifs.removeClass('active');

        this.tab_forecasts.addClass('hidden');
        this.tab_results.addClass('hidden');
        this.tab_rules.addClass('hidden');
        this.tab_gifs.addClass('hidden');

        console.log('open tab', tab_name);

        switch (tab_name) {
            case 'results':
                this.tab_link_results.addClass('active');
                this.tab_results.removeClass('hidden');
                break;

            case 'rules':
                this.tab_link_rules.addClass('active');
                this.tab_rules.removeClass('hidden');
                break;

            case 'gifs':
                this.tab_link_gifs.addClass('active');
                this.tab_gifs.removeClass('hidden');
                break;

            default:
                this.tab_link_forecasts.addClass('active');
                this.tab_forecasts.removeClass('hidden');
        }
    }

    onScoreEnter(e, el) {
        el.value = el.value.replace(/\D/g,'');

        if (el.value.length > 2) {
            el.value = el.value.substring(0, 2);
        }
    }

    saveForecast(e, el) {
        let id = el.dataset.id;
        let home = this['home-' + id].value;
        let away = this['away-' + id].value;

        if (!home || !away) {
            return;
        }

        App.getRequest('/api/save-forecast', {id: id, home: home, away: away}).onDone(response => {
            if (response.success) {
                document.location.reload();
            } else {
                if (response.auth) {
                    App.controllers.Header._openAuth();
                }
            }
        }).onFail(result => {
            console.log('fail', result);
        }).execute();
    }

    filterMatches(e, el) {
        e.preventDefault();

        if (!this.done_filter) {
            return;
        }

        this.active_filter.removeClass('active');
        this.done_filter.removeClass('active');
        this.success_filter.removeClass('active');

        document.querySelectorAll('.matches tbody tr').forEach((item) => {
            item.addClass('hidden');
        });

        switch (el.dataset.filter) {
            case 'done':
                this.done_filter.addClass('active');
                document.querySelectorAll('.matches tbody tr').forEach((item) => {
                    if (item.hasClass('done') || item.hasClass('success')) {
                        item.removeClass('hidden');
                    }
                });
                break;

            case 'success':
                this.success_filter.addClass('active');
                document.querySelectorAll('.matches tbody tr').forEach((item) => {
                    if (item.hasClass('success') || item.hasClass('success-error')) {
                        item.removeClass('hidden');
                    }
                });
                break;

            default:
                this.active_filter.addClass('active');
                document.querySelectorAll('.matches tbody tr').forEach((item) => {
                    if (item.hasClass('active')) {
                        item.removeClass('hidden');
                    }
                });
                break;
        }
    }
}